import React from "react";
import { Col, Container, Row } from "reactstrap";
import styles from "../styles/AboutPageStyle.module.css";
import ExportedShipping from "./../assets/imgs/ExportShipping.jpg";
import Ship from "../assets/imgs/about_us.png";
import Shelf from "../assets/imgs/EF Branding Website/distribution-warehouse-building-interior-large-storage-area-with-goods-shelf.jpg";
import Mission from "../assets/imgs/mission.png";
import Vision from "../assets/imgs/vision.png";
import Man from "../assets/imgs/EF Branding Website/handsome-young-man-working-with-papers.jpg";
import Woman from "../assets/imgs/EF Branding Website/beautiful-smart-asian-young-entrepreneur-business-woman-owner-sme-online-checking-product (4).jpg";
import Global from "../assets/imgs/EF Branding Website/240_F_443956484_YbGZYCLvZC0f6v2kBpNLGjpO87fCm7SI.jpg";
import { useTranslation } from "react-i18next";
import techValue from "../assets/imgs/tech-value.jpeg";
import globalValue from "../assets/imgs/global-value.jpeg";
import starValue from "../assets/imgs/star-value.jpeg";
import yearValue from "../assets/imgs/year-value.jpeg";

const AboutPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Container className={styles.about_us_container}>
        <Row>
          <Row className="py-4">
            <Col md={6} className={styles.about_us}>
              <h5 className="fw-bold">{t("about.about")}</h5>
              <p>
                "Welcome to Easy Freight International Logisitcs" . We are a
                dynamic and innovative logistics company that has been providing
                exceptional solutions since our establishment in 2016. With our
                recent public launch in November 2021, we are excited to extend
                our services to a wider audience and make a significant impact
                in the logistics industry.
              </p>
              <p>
                At Easy Freight , we understand the critical role that logistics
                plays in the success of businesses. Our team of dedicated
                professionals brings together years of industry experience and
                expertise to deliver tailored logistics solutions that meet the
                unique needs of each client.
              </p>
            </Col>
            <Col md={6}>
              <img src={Ship} className={styles.absolute_img} />
            </Col>
          </Row>
          <Row className="pb-5 mt-0 justify-content-center ms-1">
            <Row className="py-5 py-sm-0 d-flex mb-3 mt-5 justify-content-sm-center">
              <Col className="d-flex justify-content-center align-items-center">
                <img src={Mission} className={styles.about_img_second} />
              </Col>
              <Col>
                <h5 className="fw-bold">Mission:</h5>
                <p style={{ textAlign: "justify" }}>
                  Our mission is to provide reliable and efficient logistics
                  solutions that enable seamless movement of goods, connect
                  businesses globally, and contribute to the success of our
                  clients. We aim to be a trusted partner, delivering
                  exceptional service, optimizing warehousing, and adding value
                  at every step of the logistics process.
                  {/* {t("about.mission_one")} */}
                </p>
              </Col>
            </Row>
            <Row className="py-5 py-sm-0 d-flex mb-3 mt-5 justify-content-sm-center">
              <Col>
                <h5 className="fw-bold">Vision:</h5>
                <p style={{ textAlign: "justify" }}>
                  Our vision is to be a leading logistics service provider,
                  recognized for our commitment to excellence, innovation, and
                  customer satisfaction. We strive to set new industry standards
                  by leveraging cutting-edge technologies, fostering strong
                  partnerships, and continuously improving our operations. Our
                  goal is to be the preferred choice for businesses seeking
                  reliable, cost-effective, and sustainable logistics solutions.
                  {/* {t("about.mission_one")} */}
                </p>
              </Col>
              <Col className="d-flex justify-content-center align-items-center">
                <img src={Vision} className={styles.about_img_second} />
              </Col>
            </Row>
          </Row>
        </Row>
      </Container>
      <Container>
        <Row className="py-5">
          <h3 className="text-center fw-bold mb-lg-5">
            {t("about.our_value")}
          </h3>

          {/* tech */}
          <Container className="mx-5 mb-5">
            <Row>
              <Col xs={12} md={3} className="d-flex align-items-center">
                <img
                  src={techValue}
                  alt="About"
                  className={styles.values_image}
                />
              </Col>
              <Col
                xs={11}
                md={7}
                className={`d-flex flex-column justify-content-center ${styles.content_margin}`}
              >
                <div className="about-content">
                  <h3 className="fw-bold">Technology-driven Solutions</h3>
                  <p>
                    We embrace technology and leverage advanced logistics
                    management systems to streamline processes, optimize routes,
                    and provide real-time visibility of shipments. This allows
                    us to enhance efficiency, reduce costs, and deliver superior
                    customer service.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          {/* year */}
          <Container className="mx-5 mb-5">
            <Row>
              <Col xs={12} md={3} className="d-flex align-items-center">
                <img
                  src={yearValue}
                  alt="About"
                  className={styles.values_image}
                />
              </Col>
              <Col
                xs={11}
                md={7}
                className={`d-flex flex-column justify-content-center ${styles.content_margin}`}
              >
                <div className="about-content">
                  <h3 className="fw-bold">Extensive Industry Experience</h3>
                  <p>
                    Since 2016 our experiences in the logistics industry both of
                    landed and sea trade, we have developed deep expertise and
                    insights into various sectors, allowing us to deliver
                    tailored solutions that meet the unique needs of our
                    clients.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          {/* start */}
          <Container className="mx-5 mb-5">
            <Row>
              <Col xs={12} md={3} className="d-flex align-items-center">
                <img
                  src={starValue}
                  alt="About"
                  className={styles.values_image}
                />
              </Col>
              <Col
                xs={11}
                md={7}
                className={`d-flex flex-column justify-content-center ${styles.content_margin}`}
              >
                <div className="about-content">
                  <h3 className="fw-bold">Customer Focus</h3>
                  <p>
                    Customer satisfaction is at the heart of everything we do.
                    We work closely with our clients to understand their
                    specific requirements, provide personalized solutions, and
                    ensure timely and secure delivery of their goods. Building
                    long-term partnerships based on trust and reliability is our
                    priority.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          {/* global */}
          <Container className="mx-5 mb-2">
            <Row>
              <Col xs={12} md={3} className="d-flex align-items-center">
                <img
                  src={globalValue}
                  alt="About"
                  className={styles.values_image}
                />
              </Col>
              <Col
                xs={11}
                md={7}
                className={`d-flex flex-column justify-content-center ${styles.content_margin}`}
              >
                <div className="about-content">
                  <h3 className="fw-bold">Global Network</h3>
                  <p>
                    Our extensive network of partners, carriers, and agents
                    spans across China ~Myanmar, Bangkok ~ Myanmar enabling us
                    to provide seamless logistics services . We have the
                    capabilities to handle both domestic and international
                    shipments efficiently
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          {/* <div className="d-flex flex-wrap mt-5 justify-content-center justify-content-lg-start">
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>{t("about.our_value_one")}</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>{t("about.our_value_two")}</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>{t("about.our_value_three")}</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>{t("about.our_value_four")}</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>{t("about.our_value_five")}</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>
                <div className="d-flex flex-column text-center">
                  <span>{t("about.our_value_six")}</span>
                  <span>{t("about.our_value_seven")}</span>
                </div>
              </div>
            </Col>
          </div> */}
        </Row>
      </Container>{" "}
    </div>
  );
};
export default AboutPage;
